import React from 'react';
import SvgIcon from 'utils/SvgIcon';

const ChangeRequestIcon = ({ fillColor, hoverFill, style }) => (
  <SvgIcon
    {...{ fillColor, hoverFill, style }}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.125 17.25C10.5262 17.25 11.877 16.8941 13.0733 16.2277L16.5144 16.5144L16.2277 13.0733C16.8941 11.877 17.25 10.5262 17.25 9.125C17.25 4.63769 13.6123 1 9.125 1C4.63769 1 1 4.63769 1 9.125C1 13.6123 4.63769 17.25 9.125 17.25ZM12.4684 14.7005L12.6932 14.5654L14.7356 14.7356L14.5654 12.6932L14.7005 12.4684C15.3025 11.467 15.625 10.3206 15.625 9.125C15.625 5.53515 12.7149 2.625 9.12501 2.625C5.53516 2.625 2.62501 5.53515 2.62501 9.125C2.62501 12.7149 5.53516 15.625 9.12501 15.625C10.3206 15.625 11.467 15.3025 12.4684 14.7005ZM9.12528 13.1862C9.57416 13.1862 9.93805 12.8224 9.93805 12.3737C9.93805 11.9249 9.57416 11.5612 9.12528 11.5612C8.6764 11.5612 8.31251 11.9249 8.31251 12.3737C8.31251 12.8224 8.6764 13.1862 9.12528 13.1862ZM8.31251 10.75H9.93751V9.9375C9.93751 9.93948 9.94134 9.93525 9.95004 9.92567C9.97136 9.90218 10.0219 9.8465 10.1167 9.77132C10.198 9.70676 10.2233 9.69003 10.4289 9.55967C11.1287 9.11606 11.5625 8.34464 11.5625 7.5C11.5625 6.15381 10.4712 5.0625 9.12501 5.0625C7.77881 5.0625 6.68751 6.15381 6.68751 7.5H8.31251C8.31251 7.05127 8.67627 6.6875 9.12501 6.6875C9.57374 6.6875 9.93751 7.05127 9.93751 7.5C9.93751 7.78219 9.79332 8.03858 9.55885 8.18722C9.29577 8.35401 9.25209 8.38295 9.10672 8.49828C8.62348 8.88164 8.31251 9.33844 8.31251 9.9375V10.75Z"
    />
  </SvgIcon>
);

export default ChangeRequestIcon;
